import styled from "styled-components";

import { ConfirmDialog } from "primereact";

import { theme } from "../../../../styles/theme";

export const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  overflow: auto;

  ::-webkit-scrollbar {
    width: 8px !important;
  }

  ::-webkit-scrollbar-track {
    background-color: ${theme.colors.blue800} !important;
  }

  ::-webkit-scrollbar-thumb {
    background: ${theme.colors.gray800} !important;
    border-radius: 0 !important;
  }

  .header-item.header-actions {
    text-align: center;
  }
`;

export const CardWrapper = styled.div`
  margin-top: 10px;
  margin: 15px;
  border-radius: 20px;
  display: flex;
  align-items: center;
  padding: 15px;
  justify-content: space-between;
  background-color: ${theme.colors.darkBlue};

  .button-create {
    width: fit-content;
    padding: 0.70rem 1.250rem;
    white-space: nowrap;

    &:hover {
      opacity: 0.9;
    }
  }
`;

export const ConfirmDialogStyled = styled(ConfirmDialog)`
  max-width: 500px;
  .p-dialog-header {
    background-color: ${theme.colors.darkBlue};
    color: ${theme.colors.white};
    font-family: ${theme.font.poppins};
  }

  .p-dialog-content {
    background-color: ${theme.colors.darkBlue};
    color: ${theme.colors.white};
    font-family: ${theme.font.poppins};
  }

  .p-dialog-footer {
    background: ${theme.colors.darkBlue};
    font-family: ${theme.font.poppins};
    flex-direction: row-reverse;
  }
`;


export const ContainerFilter = styled.div`
  width: 100%;

  .container-form {
    margin-bottom: 0;
    padding-bottom: 0;
    border-bottom: none;

    & > div {
      padding: 0 4px;
    }
  }

  input {
    width: 100% !important;
  }

  .p-dropdown .p-dropdown-label.p-placeholder {
    color: ${theme.colors.gray500} !important;
    padding-top: 0.700rem;
  }

  .p-dropdown .p-dropdown-label {
    padding-top: 0.700rem;
  }

  .select-tooltip {
    width: unset !important;
  }
`; 